<template>
    <!-- 底部栏 -->
    <div class="footer-section">
        <div class="footer-upper">
            <div class="footer-links">
                <div class="footer-link-item">
                    <div class="footer-link-title" @click.prevent="goToUs">关于我们</div>
                </div>
                <div class="footer-link-item">
                    <div class="footer-link-title" @click.prevent="goToSupport">服务支持</div>
                </div>
                <div class="footer-link-item">
                    <div class="footer-link-title" @click.prevent="goToPaltform">产品中心</div>
                </div>
                <div class="footer-link-item">
                    <div class="footer-link-title" @click.prevent="goToConnectUs">联系我们</div>
                </div>
            </div>
        </div>
        <div class="footer-lower">
            <div class="footer-info">
                <p class="footer-text">欢迎咨询：+86 18088833233 麦先生</p>
                <p class="footer-text">公司全称：佛山市势联出海合规进出口服务有限公司</p>
                <p class="footer-text">公司地址：广东省佛山市顺德区大良万邦商业广场2座</p>
                <p class="footer-text">电子邮箱：547467337@qq.com</p>
                <p class="footer-text">
                    <span>ICP备案：</span>
                    <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: #4596dc;text-decoration: none;">
                        <span>粤ICP备2025370114号-1</span>
                    </a>
                </p>
            </div>

            <div class="footer-qrcodes">
                <div class="qr-code-placeholder1">
                    <img src="https://www.sailortrade.top/imgs/mai-qrcode.webp" class="qr-code1">
                </div>
                <div class="qr-code-placeholder2">
                    <img src="https://www.sailortrade.top/imgs/scan-qrcode.webp" class="qr-code2">
                </div>
            </div>
        </div>
        <div class="footer-lower1">
            <div class="footer-up">
                <div class="footer-info">
                    <p class="footer-text">欢迎咨询：+86 18088833233 麦先生</p>
                    <p class="footer-text">公司地址：广东省佛山市顺德区大良万邦商业广场2座</p>
                    <p class="footer-text">电子邮箱：547467337@qq.com</p>
                </div>

                <div class="footer-qrcodes">
                    <div class="qr-code-placeholder1">
                        <img src="https://www.sailortrade.top/imgs/mai-qrcode.webp" class="qr-code1">
                    </div>
                </div>
            </div>
            <div class="qr-code-placeholder2">
                <img src="https://www.sailortrade.top/imgs/scan-qrcode.webp" class="qr-code2">
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRouter } from 'vue-router';
const router = useRouter();
// Vue 3 组合式 API 实现滚动到元素的方法
const scrollToElement = (selector) => {
    // 使用 document.querySelector 查找元素
    const element = document.querySelector(selector);
    if (element) {
        element.scrollIntoView({
            behavior: 'smooth'
        });
    } else {
        console.warn(`Element with selector "${selector}" not found`);
    }
};
const goToSupport = () => {
    scrollToElement('.data-section');

};
const goToUs = () => {
    scrollToElement('.title-main');
};
const goToPaltform = () => {
    // 滚动到服务流程板块，需要根据实际页面中的元素类名来设置
    scrollToElement('.scrolling-images-section'); // 假设服务流程板块的类名是 server-main
};
const goToConnectUs = () => {
    scrollToElement('.footer-section');
};
</script>
<style scoped>
/* 底部区域板块样式 */
.footer-section {
    width: 100%;
    height: 350px;
    background-color: #333333;
    display: flex;
    flex-direction: column;
}

.footer-upper {
    height: 150px;
    display: flex;
    align-items: center;
    padding: 0 100px;
    box-sizing: border-box;
    border-bottom: #666666 solid 1px;
}

.footer-links {
    display: flex;
    align-items: center;
}

.footer-link-item {
    margin-right: 40px;
    cursor: pointer;
    transition: all 0.3s ease;
}

@media (max-width: 450px) {
    .footer-link-item {
        margin-right: 20px;
    }
}

@media (max-width: 360px) {
    .footer-link-item {
        margin-right: 10px;
    }
}

.footer-link-item:hover {
    transform: translateY(-3px);
}

.footer-link-title {
    font-size: 16px;
    color: white;
    transition: all 0.3s ease;
}

.footer-link-item:hover .footer-link-title {
    color: #00a0bc;
}


.footer-lower {
    height: 200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 50px 0 100px;
    box-sizing: border-box;
}

.footer-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.footer-text {
    font-size: 14px;
    color: white;
    margin: 5px 0;
}

.footer-qrcodes {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.qr-code-placeholder1 {
    width: 130px;
    height: 130px;
    margin-left: 20px;
}

.qr-code1 {
    width: 130px;
    height: 130px;
    object-fit: cover;
    border-radius: 8px;
}

.qr-code2 {
    width: 400px;
    height: 130px;
}

.qr-code-placeholder2 {
    width: 400px;
    height: 130px;
    margin-left: 20px;
}

.footer-lower1 {
    display: none;
}

.footer-up {
    display: flex;
    flex-direction: row;
    margin: 5% 5% 5% 5%;
}

@media (max-width: 768px) {
    .footer-section {
        height: 380px;
    }

    .footer-upper {
        padding: 0px 10px;
        height: 70px;
    }

    .footer-text {
        font-size: 12px;
    }

    .footer-lower {
        display: none;
    }

    .qr-code-placeholder1 {
        width: 100px;
        height: 100px;
        flex-shrink: 0;
        /* 防止二维码被压缩 */
        align-self: flex-end;
    }

    .qr-code1 {
        width: 100px;
        height: 100px;
    }

    .footer-lower1 {
        display: flex;
        flex-direction: column;
    }

    .footer-qrcodes {
        margin-left: 20%;
    }

    .qr-code-placeholder2,
    .qr-code2 {
        margin: 0% auto;
        width: 90vw;
        height: 100%;
    }
}
</style>